/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CommissionId, CommissionInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditRepresentativeCommissionUrl = (id: string, commissionId: CommissionId) => {
  return `/api/v1/sales/representatives/${id}/commissions/${commissionId}`;
};

/**
 * @summary Edit representative commission
 */
export const editRepresentativeCommission = async (
  id: string,
  commissionId: CommissionId,
  commissionInput: CommissionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditRepresentativeCommissionUrl(id, commissionId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(commissionInput),
  });
};

export const getRemoveRepresentativeCommissionUrl = (id: string, commissionId: CommissionId) => {
  return `/api/v1/sales/representatives/${id}/commissions/${commissionId}`;
};

/**
 * @summary Remove representative commission
 */
export const removeRepresentativeCommission = async (
  id: string,
  commissionId: CommissionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveRepresentativeCommissionUrl(id, commissionId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddRepresentativeCommissionUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}/commissions`;
};

/**
 * @summary Add representative commission
 */
export const addRepresentativeCommission = async (
  id: string,
  commissionInput: CommissionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CommissionId> => {
  return customFetch<CommissionId>(getAddRepresentativeCommissionUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(commissionInput),
  });
};
